// tslint:disable:max-line-length
import * as React from 'react';
import { createIcon } from '../createIcon';

function Check() {
  return React.createElement("svg", {
    width: "16",
    height: "12",
    viewBox: "0 0 16 12"
  }, React.createElement("path", {
    "data-fill-rule": "stroke",
    stroke: "#999",
    strokeLinecap: "square",
    strokeWidth: "2",
    d: "M2 6l4 4 8-8"
  }));
}

export var CheckIcon = createIcon(Check); // tslint:enable:max-line-length